import axios from 'axios'
import {apiURL} from "@/api/config";

let fullExcelUrl = apiURL;
let fileName = 'excelFile.xlsx';

export const setExcelConfig = (apiController='', name='excelFile.xlsx') => {
    fullExcelUrl = `${apiURL}${apiController}`;
    fileName = name;
};
export const runExcelDown = async (params) => {
    const axiosConfig= {
        method : 'post',
        url : fullExcelUrl,
        responseType : 'blob',
        data : params,
        headers: {
        }
    };

    try {
        const response = await axios(axiosConfig);

        const url = window.URL.createObjectURL(new Blob([response.data], {type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.style.display = 'none';
        anchor.setAttribute('download', fileName);
        console.log(anchor)
        document.body.appendChild(anchor);
        anchor.click();
    }catch (e) {
        console.log(e);
    }
};


export const runExcelDownByMethod = async (params,method) => { // method => 'get','post'

    const axiosConfig= {
        method : method,
        url : fullExcelUrl,
        responseType : 'blob',
        // data : params,
        params : params
    };
    console.log(axiosConfig.data, params)
    try {
        const response = await axios(axiosConfig);
        const url = window.URL.createObjectURL(new Blob([response.data], {type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const anchor = document.createElement('a');

        anchor.href = url;
        anchor.style.display = 'none';
        anchor.setAttribute('download', fileName);
        document.body.appendChild(anchor);
        anchor.click();
    }catch (e) {
        console.log(e);
    }
};

